import { render, staticRenderFns } from "./SubItem.vue?vue&type=template&id=b41409fe&"
import script from "./SubItem.vue?vue&type=script&lang=js&"
export * from "./SubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b41409fe')) {
      api.createRecord('b41409fe', component.options)
    } else {
      api.reload('b41409fe', component.options)
    }
    module.hot.accept("./SubItem.vue?vue&type=template&id=b41409fe&", function () {
      api.rerender('b41409fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/sidebar-menu/SubItem.vue"
export default component.exports